import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type UserState = {
  nickname: string;
  sessionId: number | null;
  sessionStart?: number;
  clientIp?: string;
  clientId?: string;
  currentPlayerToken?: string;
  operatorId?: number;
  currency?: string;
  uid?: string;
  vip?: number;
  balance?: number;
  realtimeBalance?: number;
  startBalance?: number;
  evoWrapperBalance?: number; // oss
  evoWrapperBalanceVersion?: number; // oss
  evoWalletBalanceVersion?: number; // oss
  historyurl?: string; // used in OperatorError dialog
  netPosition: number;
  hasInitializedBalance: boolean; // `true` if we received at least one CURRENT_BALANCE message from GE
}

const initialState: UserState = {
  nickname: 'Unknown',
  sessionId: null,
  netPosition: 0,
  hasInitializedBalance: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set(state, { payload }: PayloadAction<Partial<UserState>>) {
      return {
        ...state,
        ...payload,
      };
    },
    updateRealtimeBalanceWhenMainBetUnderLimit() {},
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
